module.exports = __webpack_public_path__ + "img/Wechat.c805c13.svg";